import { getFunnelSessionCode } from './session';

interface FunnelEventPayload {
  event_name: string;
  step_no?: number;
  event_value?: string;
  page_url?: string;
}

export async function logFunnelEvent({
  event_name,
  step_no = 0,
  event_value = '',
  page_url = window.location.href
}: FunnelEventPayload) {
  try {
    await fetch('/api/funnel_event_kaydet.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        oturum_kodu: getFunnelSessionCode(),
        event_name,
        step_no,
        event_value,
        page_url
      })
    });
  } catch (error) {
    console.error('Funnel event gönderim hatası:', error);
  }
}